
import React, { createContext, useContext, useState } from "react";

const GlobalStateContext = createContext();

export const GlobalStateProvider = ({ children }) => {
  const [question, setQuestion] = useState("");
  const [chatHistory, setChatHistory] = useState([]); // Chatbot history
  const [sqlChatHistory, setSqlChatHistory] = useState([]); // SQL Query chat history
  const [sessionId, setSessionId] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [summaries, setSummaries] = useState([]); // ⬅️ Add summaries
  const [selectedFiles, setSelectedFiles] = useState([]); // ⬅️ Store files globally


  return (
    <GlobalStateContext.Provider
      value={{
        question,
        setQuestion,
        chatHistory,
        setChatHistory,
        sqlChatHistory,
        setSqlChatHistory,
        sessionId,
        setSessionId,
        isTyping,
        setIsTyping,
        summaries, // ⬅️ Make summaries globally available
        setSummaries,
        selectedFiles, // ⬅️ Added to global state
        setSelectedFiles,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);

